/* globals Class, $ */

window.jui.ColorPickerDialog = Class.create(window.jui.ModalDialog, {
  initialize: function($super, options){
    /* jshint unused:vars */
    this.hsv = [0,0,0];
    this.tracking = false;
    this.trackingHue = false;
    this.offset = {left:0, top:0};

    this.mouseMoveListener = this.mousemove.bindAsEventListener(this);
    this.mouseUpListener   = this.mouseup.bindAsEventListener(this);

    $super(this._localOptions());
  },

  _localOptions: function() {
    var chooseBtnOpts = {
      id: 'choose',
      label: 'Choose',
      action: this.pick.bind(this)
    };

    var cancelBtnOpts = {
      id: 'cancel',
      label: 'Cancel',
      action: this.cancel.bind(this)
    };

    chooseBtnOpts.class = 'action color-picker-choose-btn';
    cancelBtnOpts.class = 'push-left';

    return {
      title: "Color Picker",
      actions: [cancelBtnOpts, chooseBtnOpts],
      layoutRules: {
        method: window.jui.ModalDialog.centerInViewPort,
        options: {
          size: {
            width: 395,
            height: 380
          }
        }
      },
      closeX: true
    };
  },

  installUI: function($super) {
    $super();

      this.colorPopdown = new Element('div', {className: 'color-popdown large-picker light'});
        this.colorInputs = new Element('div', {className: 'color-inputs'});
          this.colorComps = new Element('div', {className: 'color-components'});

            this.satAndHue = new Element('div', {className: 'saturation-and-hue'});

              this.satCont = new Element('div', {className: 'saturation'});
                this.satVal = new Element('div', {className:'color-picker-sat-val'});
                this.sat = new Element('div', {className:'color-picker-sat'});
                this.val = new Element('div', {className:'color-picker-val'});
                this.crosshairs = new Element('div', {className:'color-picker-cross-hairs'});
              this.satCont.insert(this.satVal);
              this.satCont.insert(this.sat);
              this.satCont.insert(this.val);
              this.satCont.insert(this.crosshairs);

              this.hueCont = new Element('div', {className: 'hue'});
                this.hue = new Element('div', {className:'color-picker-hue'});
                this.hueIndicator = new Element('div', {className:'color-picker-hue-indicator'});
              this.hueCont.insert(this.hue);
              this.hueCont.insert(this.hueIndicator);
            this.satAndHue.insert(this.satCont);
            this.satAndHue.insert(this.hueCont);

          this.colorComps.insert(this.satAndHue);

          this.colorValues = new Element('div', {className: 'color-values'});
            this.colorPreviews = new Element('div', {className:'color-previews'});
              this.after = new Element('div', {className:'color-picker-after color-new'});
              this.before = new Element('div', {className:'color-picker-before color-current'});
            this.colorPreviews.insert(this.after);
            this.colorPreviews.insert(this.before);
          this.colorValues.insert(this.colorPreviews);

        this.colorInputs.insert(this.colorComps);
        this.colorInputs.insert(this.colorValues);
      this.colorPopdown.insert(this.colorInputs);
    this.contentPanel.insert(this.colorPopdown);

    this.crosshairs.observe('mousedown', this.valClicked.bind(this));
    this.val.observe('mousedown', this.valClicked.bind(this));
    this.hue.observe('mousedown', this.hueClicked.bind(this));
    this.hueIndicator.observe('mousedown', this.hueClicked.bind(this));
  },

  valClicked: function(e) {
    this.offset = this.val.cumulativeOffset();

    this.hsv[1] = (e.pointerX() - this.offset.left - 1) / 256.0;
    this.hsv[2] = 1 - ((e.pointerY() - this.offset.top - 1) / 256.0);

    this.updateColor();
    this.setTracking('val');
  },

  hueClicked: function(e) {
    this.offset = this.hue.cumulativeOffset();

    this.hsv[0] = 1 - ((e.pointerY() - this.offset.top- 1) / 256.0);
    this.updateColor();
    this.setTracking('hue');
  },

  mouseup:function( e ){
    Event.stop( e );
    this.setTracking( false );
  },

  mousemove:function( e ){
    Event.stop( e );
    switch (this.tracking) {
      case 'val':
        this.hsv[1] = Math.max(0,Math.min((e.pointerX() - this.offset.left - 1) / 256.0, 1));
        this.hsv[2] = Math.max(0,Math.min(1 - ((e.pointerY() - this.offset.top - 1) / 256.0), 1));
        break;
      case 'hue':
        this.hsv[0] = Math.max(0,Math.min(1 - ((e.pointerY() - this.offset.top - 1) / 256.0), 1));
        break;
    }
    this.updateColor();
  },

  setTracking: function( b ) {
    if ( this.tracking === b ) {
      return;
    }

    this.tracking = b;
    if ( b !== false ) {
      $( window.document ).observe( 'mouseup', this.mouseUpListener );
      $( window.document ).observe( 'mousemove', this.mouseMoveListener );
    } else {
      $( window.document ).stopObserving( 'mouseup', this.mouseUpListener );
      $( window.document ).stopObserving( 'mousemove', this.mouseMoveListener );
    }
  },

  updateColor: function() {
    this.rgb = this.hsvToRgb(this.hsv);
    this.hex = this.rgb.invoke('toColorPart').join('');
    var hueHex = this.hsvToRgb([this.hsv[0], 1, 1]).invoke('toColorPart').join('');

    this.satVal.style.backgroundColor = '#'+hueHex;
    this.after.style.backgroundColor = '#'+this.hex;

    var crosshairOffsets = {
      x: this.crosshairs.clientWidth / 2,
      y: this.crosshairs.clientHeight / 2
    };

    var hueIndicatorOffset = {
      y: this.hueIndicator.clientHeight / 2
    };

    this.crosshairs.style.left = ((this.hsv[1]) * 256 - crosshairOffsets.x) + 'px';
    this.crosshairs.style.top = ((1 - this.hsv[2]) * 256 - crosshairOffsets.y) + 'px';
    this.hueIndicator.style.top = ((1 - this.hsv[0]) * 256 - hueIndicatorOffset.y) + 'px';
  },

  cancel: function() {
    this.close();
  },

  pick: function() {
    this.close();
    this.options.callback(this.hex);
  },

  open: function($super,hex, options) {
    $super();
    if (options.callback) {
      this.options.callback = options.callback;
    }

    this.hex = hex.strip().length > 0 ? hex : 'ffffff';
    this.rgb = this.hexToRgb(this.hex);
    this.hsv = this.rgbToHsv(this.rgb);

    this.before.style.backgroundColor = '#'+this.hex;
    this.updateColor();
  },

  hexToRgb: function(hex) {
    var r, g, b;

    if (hex.length === 3) {
      r = parseInt((hex).substring(0,1),16);
      g = parseInt((hex).substring(1,2),16);
      b = parseInt((hex).substring(2,3),16);
      r += r * 16;
      g += g * 16;
      b += b * 16;
    } else {
      r = parseInt((hex).substring(0,2),16);
      g = parseInt((hex).substring(2,4),16);
      b = parseInt((hex).substring(4,6),16);
    }

    return [r,g,b];
  },

  hsvToRgb: function(hsv) {
    var h = Math.max(0, Math.min(1, hsv[0])),
        s = Math.max(0, Math.min(1, hsv[1])),
        v = Math.max(0, Math.min(1, hsv[2]));

    var r, g, b;

    var i = Math.floor(h * 6);
    var f = h * 6 - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    switch (i % 6) {
      case 0:
        r = v; g = t; b = p; break;
      case 1:
        r = q; g = v; b = p; break;
      case 2:
        r = p; g = v; b = t; break;
      case 3:
        r = p; g = q; b = v; break;
      case 4:
        r = t; g = p; b = v; break;
      case 5:
        r = v; g = p; b = q; break;
    }

    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
  },

  rgbToHsv: function(rgb) {
    var r = rgb[0]/255, g = rgb[1]/255, b = rgb[2]/255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;

    if (max === min) {
      h = 0; // achromatic
    } else {
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }
      h /= 6;
    }

    return [h, s, v];
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/jui/color_picker_dialog.js
// module id = 276
// module chunks = 0 1